import { useSelector } from "react-redux"

export const useGetIsShowBalanceOfAdditionalActivitiesInLeftMenu = (): boolean => {
    const showAllStudentBalancesInLeftMenu = useSelector((store: any) => store.settings.showAllStudentBalancesInLeftMenu == '1')
    const isStudentBalancesEnabled = useSelector((store: any) => store.settings.isStudentBalancesEnabled == '1')
    
    return isStudentBalancesEnabled && showAllStudentBalancesInLeftMenu
}
